<app-subs></app-subs>
<div>
    <div id="subsub-container">
        <div id="day-container">
            <h2>Today</h2>
        </div>
        <app-video-list
        [width] = 'www'
        ></app-video-list>
    </div>

    <div id="subsub-container">
        <div id="day-container">
            <h2>Yesterday</h2>
        </div>
        <app-video-list
        [width] = 'www'
        ></app-video-list>
    </div>

    <div id="subsub-container">
        <div id="day-container">
            <h2>Thursday - 18/03/2021</h2>
        </div>
        <app-video-list
        [width] = 'www'
        ></app-video-list>
    </div>
</div>